/**
 * The OAuth redirect URI — defined once, for every flow that needs one.
 *
 * ── Why this is a function and not a string literal in two places ────────
 * It was two places, and they disagreed by ONE CHARACTER. Sign-in sent
 * `location.origin`; the device-pairing page sent `${location.origin}/`.
 * Google compares redirect URIs by exact string, so the trailing slash makes
 * them different URIs, and pairing died at Google with:
 *
 *   Error 400: redirect_uri_mismatch
 *
 * The same slash would have failed a SECOND gate immediately afterwards:
 * GRIZZLY_REDIRECT_URI_ALLOWLIST on the API is `https://<host>` with no slash,
 * so the token exchange would have rejected it too. Two independent checks,
 * one typo, and no test could see it — both flows were individually correct.
 *
 * Anything that builds an authorization URL must call this, and the value used
 * to REDEEM a code must be byte-identical to the one used to request it, which
 * is the other half of why this is centralised.
 *
 * No trailing slash: `location.origin` is already `scheme://host[:port]`, and
 * that is the form registered in the Google client and in the API's allowlist.
 */
export function oauthRedirectUri(): string {
  return location.origin
}
